import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Adam Locke --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Identify issues behind suspicious trends";
const frontMatter = {
  "title": "Identify issues behind suspicious trends",
  "description": "Learn how to use differential diagnosis to identify issues in your telemetry data most closely correlated with suspicious behavior."
};
export function useTOC(props) {
  return [{
    value: "Identify issues in traces",
    id: "identify-issues-in-traces",
    depth: 2
  }, {
    value: "Identify trends in metrics",
    id: "identify-trends-in-metrics",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Identify issues behind suspicious trends"}</_components.h1>{"\n"}<_components.p>{"When troubleshooting issues, finding the root cause of a problem as quickly as\npossible is critical. Chronosphere Observability Platform includes\n"}<_components.em>{"differential diagnosis"}</_components.em>{" to help developers find the source of slowdowns or failures\nby identifying suspicious trends in your telemetry data and what’s causing them."}</_components.p>{"\n"}<_components.p>{"Differential diagnosis lets developers resolve service performance issues without\nwriting queries or needing knowledge of the entire system. Differential diagnosis\nranks and highlights the most probable sources of issues so developers can test\nhypotheses and compare trends to identify root causes."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"In Trace Explorer or from service pages, use\n"}<_components.a href="/investigate/analyze/differential-diagnosis/traces">{"differential diagnosis for trace"}</_components.a>{" to\nidentify trends and immediately scan through all related tags and values to pinpoint\nthe exact "}<_components.code>{"tag:value"}</_components.code>{" pairs most closely correlated with suspicious behavior."}</_components.p>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p>{"In Metrics Explorer or from service pages, use\n"}<_components.a href="/investigate/analyze/differential-diagnosis/metrics">{"differential diagnosis for metrics"}</_components.a>{"\nto examine time series anomalies, such as unusual shapes in their metrics like\nspikes and dips, and quickly understand what dimensions are contributing to an issue."}</_components.p></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/investigate/analyze/differential-diagnosis',
  {"filePath":"pages/investigate/analyze/differential-diagnosis.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)